import React, { type ReactElement } from 'react';
import { Colors, Flex, Typography } from '@banhala/ui-kit';

export const IconButton: React.FC<{
  label: string;
  typographyType: 'body3' | 'body5' | 'subtitle4';
  icon: ReactElement<{ width: number; height: number; fill: string }>;
  onPress: () => void;
}> = props => {
  return (
    <Flex.Row
      alignItems={'center'}
      padding={props.typographyType === 'body3' ? undefined : { vertical: 8 }}
      onPress={props.onPress}
      gap={props.typographyType === 'body3' ? 4 : undefined}
    >
      <Typography
        type={props.typographyType}
        color={
          props.typographyType === 'body3'
            ? 'content_secondary'
            : 'content_tertiary'
        }
      >
        {props.label}
      </Typography>
      {React.cloneElement(props.icon, {
        width: 12,
        height: 12,
        fill: Colors.content_tertiary,
      })}
    </Flex.Row>
  );
};
